import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="bg-mist bg-grid-light py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="22etwkfukigth">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="1yet802dr8p8p">
        <div className="text-center" data-id="element-22" data-mp="1anxkvik8ui7s">
          <GiftIcon className="mx-auto h-10 w-10 text-steel" data-id="element-23" data-mp="1aoywpp9338qk" />
          <p className="mt-4 font-mono text-[11px] font-bold uppercase tracking-[.2em] text-steel" data-id="element-24" data-mp="15pw1sxmtiiwb">Siempre incluidos · siempre gratis</p>
          <h2 id="bonus-title" className="mt-3 text-3xl font-extrabold uppercase text-ink sm:text-4xl" data-id="element-25" data-mp="1jibx1c9h9cmo">Los {totalBonuses} bonos exclusivos</h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-26" data-mp="qzy8y4dy150s">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex flex-col rounded-md border p-6 shadow-card ${bonus.wide ? 'bg-stage-deep border-2 border-gold text-onDark md:col-span-2' : 'bg-ivory border-line'}`} data-id="element-27" data-mp="mws3v02khjvw" data-mpi={index}>
                <span className={`mb-5 flex h-10 w-10 items-center justify-center rounded-sm ${bonus.wide ? 'bg-gold text-petrolDark' : 'bg-petrolDark text-gold'}`} data-id="element-28" data-mp="1vrs8i2nuzuls">
                  <Icon className="h-5 w-5" data-id="element-29" data-mp="25s2nnstgfc3l" />
                </span>
                <p className={`font-mono text-[10px] font-bold uppercase tracking-[.18em] ${bonus.wide ? 'text-gold' : 'text-steel'}`} data-id="element-30" data-mp="3c7czuudq2n2o">
                  Bono {bonus.number}
                </p>
                <h3 className={`mt-2 text-lg font-extrabold uppercase leading-tight ${bonus.wide ? 'text-white' : 'text-ink'}`} data-id="element-31" data-mp="1h2m2p87xdjx0">
                  {bonus.title}
                </h3>
                <p className={`mt-3 text-sm leading-relaxed ${bonus.wide ? 'text-mutedDark' : 'text-muted'}`} data-id="element-32" data-mp="1q3tpat12wwb9">{bonus.description}</p>

                {bonus.items && <ul className="mt-4 flex flex-wrap gap-2" data-id="element-33" data-mp="1m0drvuh6qrxi">
                    {bonus.items.map(item => <li key={item} className={`rounded-sm px-3 py-1 text-xs font-semibold ${bonus.wide ? 'border border-lineDark bg-petrolDark text-mutedDark' : 'border border-line bg-mist text-muted'}`} data-id="element-34" data-mp="yajffe0s35ds">
                        {item}
                      </li>)}
                  </ul>}

                {bonus.purpose && <p className={`mt-4 rounded-sm border-l-2 border-steel px-4 py-3 text-sm ${bonus.wide ? 'panel-dark border-l-gold text-onDark' : 'bg-steelSoft text-deep'}`} data-id="element-35" data-mp="al8o0n5bincb">
                    Su función es <b className="font-extrabold uppercase tracking-wide" data-id="element-36" data-mp="3ms5ymejx7pku">{bonus.purpose}</b>
                  </p>}

                {bonus.progression && <div className="mt-4 flex flex-wrap items-center gap-x-2 gap-y-1 font-mono text-[11px] font-bold uppercase tracking-[.12em] text-steel" data-id="element-37" data-mp="j9mgw5yvc24a">
                    {bonus.progression.map((step, stepIndex) => <React.Fragment key={step} data-id="element-38" data-mp="9b6nfwcdcgrm" data-mpi={stepIndex}>
                        {stepIndex > 0 && <ArrowRightIcon className="h-3 w-3 text-gold" aria-hidden="true" data-id="element-39" data-mp="ea02ht7b0ftw" />}
                        <span data-id="element-40" data-mp="2u1fldtegkwzx">{step}</span>
                      </React.Fragment>)}
                  </div>}

                <p className={`mt-5 flex flex-wrap items-center justify-between gap-3 border-t pt-4 text-sm ${bonus.wide ? 'border-lineDark' : 'border-line'}`} data-id="element-41" data-mp="2z2lbdjgqi65r">
                  <span className={bonus.wide ? 'text-mutedDark line-through' : 'text-muted line-through'} data-id="element-42" data-mp="35id6sacobkhx">Valor {bonus.value}</span>
                  <span className="inline-flex items-center rounded-sm bg-gold px-3 py-1 font-mono text-xs font-bold uppercase tracking-[.14em] text-petrolDark" data-id="element-43" data-mp="30kbm5kzlnd4c">
                    Gratis
                  </span>
                </p>
              </motion.article>;
        })}
        </div>

        <div className="bg-stage-deep bg-grid mt-8 flex flex-col items-center justify-between gap-4 rounded-md border border-gold/40 px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-44" data-mp="3o7tizuxq11e6">
          <p className="font-mono text-[11px] font-bold uppercase tracking-[.2em] text-gold" data-id="element-45" data-mp="2cu7kvk9vvpgi">Total de bonos</p>
          <p className="font-display text-2xl font-extrabold uppercase text-white sm:text-3xl" data-id="element-46" data-mp="27ubn42rs4u9e">
            {totalBonuses} bonos exclusivos
          </p>
        </div>

        <p className="mx-auto mt-6 max-w-xl rounded-sm border-l-2 border-steel bg-steelSoft px-5 py-4 text-center text-sm text-deep" data-id="element-47" data-mp="sbnc45799u9n">
          Valor total de bonos <span className="mx-1 text-muted line-through" data-id="element-48" data-mp="x95mm00x8hjr">{bonusTotalValue}</span>
          <b className="font-extrabold" data-id="element-49" data-mp="122i5rumtzw54">→ GRATIS con tu Megapack</b>
        </p>
      </div>
    </section>;
}